import { api } from "@/api"
import type {
  PaginatedResponse,
  PaginationQuery,
} from "@/utils/utilityTypes"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type ListUsersFilter = Pick<ListUsersQuery, "search">

export type ListUsersOrdering =
  | "email"
  | "name"
  | "lastLogin"
  | "createdAt"

type ListUsersQuery = {
  search?: string
  ordering?: ListUsersOrdering | `-${ListUsersOrdering}`
} & PaginationQuery

export type ListUsersResponseItem = {
  id: string
  email: string
  firstName: string
  lastName: string
  isActive: boolean
  lastLogin: Date | null
  createdAt: Date
}

const listUsers = async (query?: ListUsersQuery) => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      PaginatedResponse<ListUsersResponseItem>
    >
  >("/users/", { query: query })

  return {
    ...body,
    items: body.items.map((user) => ({
      ...user,
      createdAt: DateFns.parseISO(user.createdAt),
      lastLogin: user.lastLogin
        ? DateFns.parseISO(user.lastLogin)
        : null,
    })),
  }
}

export const useUsers = (
  query?: MaybeRef<ListUsersQuery>
) =>
  useQuery({
    queryKey: [BASE_USERS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listUsers(query_),
    keepPreviousData: true,
  })
